import { Field, FieldProps } from 'formik';
import React from 'react';
import { injectIntl, InjectedIntl } from 'react-intl';
import styled from 'styled-components';
import { PayVaultAPIService } from '../../../../../api/payVault/payVaultAPI';
import ErrorMessage from '../../../../../app/common/components/errorMessage/ErrorMessage';
import { TranslationHelpers } from '../../../../../i18n/translationHelpers';
import PaymentOutterInput from './PaymentOutterInput';

export const ExpiryDateIFrameRow = styled.div`
    display: flex;
    flex: 1 1 50%;
    & > div:nth-child(1) {
        margin-right: 4%;
    }
`;

export const ExpiryDateIFrameCol = styled.div`
    width: 50%;
    position: relative;
`;

export const ExpiryDateIFrameField = styled.div`
    width: 100%;
`;

export const ExpiryDateErrorMessageRow = styled.div`
    display: flex;
    flex: 1 1 100%;
`;

const ErrorMessageWrapper = styled.div`
    margin-left: 0.75rem;
`;

interface IPayVaultExpiryDateFieldProps {
    intl: InjectedIntl;
}

interface IPayVaultExpiryDateFieldState {
    fieldValidationError: boolean;
    yearFocus: boolean;
    monthFocus: boolean;
}

class PayVaultExpiryDateField extends React.Component<
    IPayVaultExpiryDateFieldProps,
    IPayVaultExpiryDateFieldState
> {
    private readonly ID: string;

    constructor(props: IPayVaultExpiryDateFieldProps) {
        super(props);
        this.ID = 'payvault-expiry-date-field';

        this.validate = this.validate.bind(this);
        this.renderInputField = this.renderInputField.bind(this);
        this.state = {
            fieldValidationError: false,
            yearFocus: false,
            monthFocus: false,
        };
    }

    public render() {
        return (
            <div>
                <Field
                    onBlur={this.validate}
                    name={this.ID}
                    validate={this.validate}
                    render={this.renderInputField}
                />
            </div>
        );
    }
    public renderInputField({ form: { setTouched, touched } }: FieldProps) {
        PayVaultAPIService.expirationMonthEventListener(() => {
            touched['expireMonth'] = true;
            setTouched(touched);
        });
        PayVaultAPIService.expirationMonthFocusEventListener(() => {
            this.setState({
                monthFocus: true,
            });
        });
        PayVaultAPIService.expirationMonthBlurEventListener(() => {
            touched['expireMonth'] = true;
            setTouched(touched);
            this.setState({
                monthFocus: false,
            });
        });

        PayVaultAPIService.expirationYearEventListener(() => {
            touched['expireYear'] = true;
            setTouched(touched);
        });
        PayVaultAPIService.expirationYearFocusEventListener(() => {
            this.setState({
                yearFocus: true,
            });
        });
        PayVaultAPIService.expirationYearBlurEventListener(() => {
            touched['expireYear'] = true;
            setTouched(touched);
            this.setState({
                yearFocus: false,
            });
        });

        const { fieldValidationError, yearFocus, monthFocus } = this.state;
        const showError = (touched['expireMonth'] || touched['expireYear']) && fieldValidationError;
        const monthLabelClassName =
            !!showError || this.state.monthFocus ? 'form-label-focus' : 'form-label';
        const yearLabelClassName =
            !!showError || this.state.yearFocus ? 'form-label-focus' : 'form-label';

        return (
            <>
                <ExpiryDateIFrameRow>
                    <ExpiryDateIFrameCol>
                        <label className={monthLabelClassName} id="expiry_month">
                            {TranslationHelpers.getFormattedMessage('label.month_payment_edit')}*
                        </label>
                        <PaymentOutterInput
                            data-qa-id="pv-expiry-month-field"
                            id="my-expiration-month-mount"
                            showError={showError}
                            field={'date'}
                            focus={monthFocus}
                            aria-labelledby="expiry_month"
                        ></PaymentOutterInput>
                    </ExpiryDateIFrameCol>

                    <ExpiryDateIFrameCol>
                        <label className={yearLabelClassName} id="expiry_year">
                            {TranslationHelpers.getFormattedMessage('label.year_payment_edit')}*
                        </label>
                        <PaymentOutterInput
                            data-qa-id="pv-expiry-year-field"
                            id="my-expiration-year-mount"
                            showError={showError}
                            field={'date'}
                            focus={yearFocus}
                            aria-labelledby="expiry_year"
                        ></PaymentOutterInput>
                    </ExpiryDateIFrameCol>
                </ExpiryDateIFrameRow>

                {showError && (
                    <ErrorMessageWrapper>
                        <ErrorMessage
                            message={TranslationHelpers.getMessageDescriptor(
                                'error.expiry_required',
                            )}
                            dataQaId="payvault-expiry-date-error-field"
                        />
                    </ErrorMessageWrapper>
                )}
            </>
        );
    }

    private async validate(): Promise<string> {
        const isValid: boolean | undefined = await PayVaultAPIService.validateExpiration();
        if (isValid !== undefined && !isValid) {
            this.setState({ fieldValidationError: true });
            return 'card expiration failure';
        } else {
            this.setState({ fieldValidationError: false });
            return '';
        }
    }
}
export default injectIntl(PayVaultExpiryDateField);
